// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__22dSu","label":"Category_label__2ZfXK","content":"Category_content__1shk5","header":"Category_header__3DkWT","location":"Category_location__1OJBn"};